'use client';

import { useUpdate } from '@lilib/hooks';
import { GoogleTagManager, sendGTMEvent } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import { useRef } from 'react';

import { GTM_KEY, IS_PRODUCTION } from '@commons/utils/constants';

/**
 * GoogleTagManagerWrapper component.
 *
 * Injects the Google Tag Manager script into the application.
 * Also sends a page_view event when the pathname changes (ignores the mount event).
 *
 * @see https://nextjs.org/docs/app/building-your-application/optimizing/third-party-libraries#google-tag-manager
 */

const GoogleTagManagerWrapper = () => {
  const pathname = usePathname();
  const previous = useRef('');

  useUpdate(() => {
    if (IS_PRODUCTION) {
      sendGTMEvent({ event: 'virtual_page_view', value: pathname, previous });
      previous.current = pathname;
    }
  }, [pathname]);

  if (!IS_PRODUCTION) {
    return null;
  }

  return <GoogleTagManager gtmId={GTM_KEY} />;
};

export default GoogleTagManagerWrapper;
